import statementTransactionsTableTemplate from './reactStatementTransactionsTable.html';
import { AccountService } from '../../../services/AccountService';
import { accounts, statements, transactions, USER_ACC_REACT, TRANSACTION_TYPES } from '../../../services/arsweb/RoutingPaths';
import { reactTransactionCols } from '../transactions/transactionsDetailColDefs';
import { STATEMENT_TRANSACTIONS_TITLE } from '../../../services/arsweb/TableTitles';
import {ReactTableController} from "../reactTableController";
import { REPORT_TYPE } from '../../report/ReportModalController';
import {SearchableItemService} from "../../../services/SearchableItemService";

export const TABLEPARAMS = 'statementTransactionsTableParams';

/** @ngInject */
export function reactStatementTransactionsTable() {
    return {
        restrict: 'E',
        scope: {
            tableId: '@',
            fractionDigits: '=',
            hideColumns: '=',
            noInitTotal: '=',
            height: '@'
        },
        templateUrl: statementTransactionsTableTemplate,
        controller: ReactStatementTransactionsTableController,
        controllerAs: 'statementTransactionsTableController'
    };
}
export const defaultSortModel = [
    {
        colId: 'f61BookDate',
        sort: 'desc',
        sortIndex: 0
    }
];
/** @ngInject */
export class ReactStatementTransactionsTableController extends ReactTableController {

    constructor($scope, userService, arsMainDependencies) {
        const reportOptions = {options: [ REPORT_TYPE.PDF_TRANSACTION_STMT, REPORT_TYPE.MT940_ACTUAL_STATEMENT,
                                            REPORT_TYPE.PDF_ACTUAL_STATEMENT, REPORT_TYPE.CSV_TRANSACTION_REPORT,
                                            REPORT_TYPE.XLSX_TRANSACTION_REPORT ]};
        const statementID = arsMainDependencies.$state.params.id;
        super($scope, userService, arsMainDependencies, "", new AccountService(userService),
            accounts + statements + "/" + statementID + transactions, STATEMENT_TRANSACTIONS_TITLE, TABLEPARAMS,
            "transactionID", true, reportOptions, defaultSortModel);

        this.isUserReport = false;
        const searchService = new SearchableItemService(userService);
        const transactionTypesPromise = searchService.backendService.getUserData(TRANSACTION_TYPES + statements + "/" + statementID);
        $scope.$on('consolitationcurrency.change', () => this.resetGridSelection());
        this.backendService.service.config.params.filter = {};
        this.ftsMainDependencies.initCompletedPromise.then(() => this.initGrid(userService, statementID, transactionTypesPromise));
        
        const parentOnReport = this.defaultReactGridParams.onReport;
        this.defaultReactGridParams.onReport = (selectedNodes) => {
            this.updateReportTypesForSelection();
            parentOnReport.call(this, selectedNodes);
        };
    }

    initGrid(userService, statementId, transactionTypesPromise) {
        userService.promise.then(()=> {
            // react account columns
            this.colDefs = reactTransactionCols(this.translate, userService.filterFormatter, transactionTypesPromise,
                this.fractionDigits, { showCamt053: true });
            this.initCols();
            // react gridParameters for account table
            const intradayEntriesGridParams = {
                columnDefs: this.colDefs,
                url: this.backendService.service.getServiceUrl(USER_ACC_REACT + statements + "/" + statementId + transactions)};
            this.reactGridParams = {...this.defaultReactGridParams, ...intradayEntriesGridParams};
        });
    }

    updateReportTypesForSelection() {
        const options = this.exportController.reportOptions.options;
        // Remove previous CAMT053 if present
        this.exportController.reportOptions.options = options.filter(opt =>
            opt !== REPORT_TYPE.CAMT053_ACTUAL_STATEMENT
        );

        // Add CAMT053 if flag is true for this grid
        if (this.getCamt05xFlag()) {
            this.exportController.reportOptions.options.push(REPORT_TYPE.CAMT053_ACTUAL_STATEMENT);
        }
    }
}
